(function($){

    // Menu animations
    $('#trigger').on('click', function(){

        $('body').addClass('disableScroll');
        $(this).addClass('open');
        $('#mainMenu').fadeIn(100).animate({left: '0'});
        $('#siteLogo').addClass('reposition');
        $('#siteLogo').animate({}, 750, function(){
            $(this).css('z-index', 90);
        });
        $('#header__contact-button').animate({}, 750, function(){
            $(this).css('opacity', 0);
        });
        $('.header__logo-image').animate({}, 750, function(){
            $(this).css('opacity', 0);
        });
        $('#triggerContainer').animate({}, 750, function(){
            $(this).css('opacity', 0);
        });

    });

    $('#mobile-close-btn').on('click', function(){

        $('#trigger').removeClass('open');
        $('body').removeClass('disableScroll');
        $('#siteLogo').animate({}, 1000, function(){
            $(this).removeClass('reposition');
        });
        $('#header__contact-button').animate({}, 1000, function(){
            $(this).css('opacity', 1);
        });
        $('.header__logo-image').animate({}, 3000, function(){
            $(this).css('opacity', 1);
        });
        $('#triggerContainer').animate({}, 1000, function(){
            $(this).css('opacity', 1);
        });
        $('#mainMenu').animate({left: '-100vh'}).fadeOut(1000);
    });

    $('#mainMenu a').on('click', function(){

    	if($('#trigger').hasClass('open')){

	        $('#trigger').removeClass('open');
	        $('body').removeClass('disableScroll');
	        $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#mainMenu').animate({left: '-100vh'}).fadeOut(1000);

	    }

    });

    // Scroll on click
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 1000);
    });


	// Slick Sliders
	$('#slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
		dots: true,
		arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
        nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
        ]
	});


    // Accordions
    $(function() {
        $('.accordion-answer').hide();
        $('.accordion-question:first').addClass('active').next().slideDown('slow');
        $('.accordion-question').click(function(){
            if($(this).next().is(':hidden')) {
                $('.accordion-question').removeClass('active').next().slideUp('slow');
                $(this).toggleClass('active').next().slideDown('slow');
            } else if($(this).next().is(':visible')) {
                $(this).toggleClass('active').next().slideUp('slow');
            }
        });
    });


    // Remove empty paragraphs
    $('p:empty').remove();

    // Animate headings
    document.querySelectorAll('.site-content p, .site-content h1, .site-content h2, .site-content h3, .site-content img').forEach(function(element){
        element.setAttribute('data-aos', 'fade-up')
        element.setAttribute('data-aos-duration','1000')
    });
    
    // Initiate aos animations
	AOS.init();

})(jQuery);